/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIMaterialRequest
 */
export interface APIMaterialRequest {
    /**
     * 
     * @type {string}
     * @memberof APIMaterialRequest
     */
    name: string;
}

/**
 * Check if a given object implements the APIMaterialRequest interface.
 */
export function instanceOfAPIMaterialRequest(value: object): value is APIMaterialRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APIMaterialRequestFromJSON(json: any): APIMaterialRequest {
    return APIMaterialRequestFromJSONTyped(json, false);
}

export function APIMaterialRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIMaterialRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function APIMaterialRequestToJSON(value?: APIMaterialRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
    };
}

